import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getExchangeStatusCatalog = createAsyncThunk('/getExchangeStatusCatalog',
  async () => {
    const response = await axios.get('/GetExchangeStatusCatalog');
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const getStatusGroupList = createAsyncThunk(
  '/getStatusGroupList',
  async () => {
    const response = await axios.get('/GetStatusGroupList/');
    return response.data;
  }
);
export const getAnnouncementInfo = createAsyncThunk(
  '/getAnnouncementInfo',
  async (roleId) => {
    const response = await axios.get(`/GetAnnouncementInfo/${roleId}`);
    return response.data;
  }
);

export const getChangeStatusDetail = createAsyncThunk(
  '/getUserTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetChangeStatusDetail/${id}`);
    return response.data;
  }
);

const exchangeStatusSlice = createSlice({
  name: 'exchangeStatus',
  initialState: {
    loading: false,
    error: '',
    ExchangeStatus:[],
    StatusDescriptions:[],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    MobileStatus: '',
    MobileStatusId: 0,
    MobileStatusList: [],
    Announcement:[],
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.StatusDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changeMobileStatus(state, action) {
      state.MobileStatus = action.payload;
      state.MobileStatusId = state.MobileStatusList.find((m) => m.Description === state.MobileStatus).ID;
    },
    changeMobileStatusId(state, action) {
      state.MobileStatusId = action.payload;
    },
  },
  extraReducers: {
    [getExchangeStatusCatalog.pending]: (state) => {
      state.loading = true;
    },
    [getExchangeStatusCatalog.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeStatusCatalog.fulfilled]: (state, action) => {
      state.ExchangeStatus= action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.StatusDescriptions = action.payload;
      state.loading = false;
    },
    [getChangeStatusDetail.pending]: (state) => {
      state.loading = true;
    },
    [getChangeStatusDetail.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getChangeStatusDetail.fulfilled]: (state, action) => {
      state.StatusDescriptions = action.payload;
      state.loading = false;
    },
    [getStatusGroupList.pending]: (state) => {
      state.loading = true;
    },
    [getStatusGroupList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading=false;
    },
    [getStatusGroupList.fulfilled]: (state, action) => {
      state.MobileStatusList = action.payload;
      state.loading = false;
    },
    [getAnnouncementInfo.pending]: (state) => {
      state.loading = true;
    },
    [getAnnouncementInfo.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getAnnouncementInfo.fulfilled]: (state, action) => {
      state.Announcement= action.payload;
      state.loading = false;
    },
  }

});
export const exchangeStatusActions = exchangeStatusSlice.actions;

export default exchangeStatusSlice;